import React from "react";
import { Dialog, DialogContent, Grid } from "@mui/material";
import ModalDialogTitle from "../../common/ModalDialogTitle";
import HeadCount from "../../CcpSchool/CcpStatsAndTrends/inc/HeadCount";
import CreditHours from "../../CcpSchool/CcpStatsAndTrends/inc/CreditHours";
import Top10Courses from "../../CcpSchool/CcpStatsAndTrends/inc/Top10Courses";
import Gender from "../../CcpSchool/CcpStatsAndTrends/inc/Gender";
import GradeLevel from "../../CcpSchool/CcpStatsAndTrends/inc/GradeLevel";
import CourseModality from "../../CcpSchool/CcpStatsAndTrends/inc/CourseModality";

const DistrictSchoolData = ({ open, onClose, schoolId }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <ModalDialogTitle onClose={onClose}>School Data</ModalDialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <HeadCount schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={6}>
            <CreditHours schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={12}>
            <Top10Courses schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={12}>
            <Gender schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={12}>
            <GradeLevel schoolId={schoolId} />
          </Grid>
          <Grid item xs={12} md={12}>
            <CourseModality schoolId={schoolId} />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default DistrictSchoolData;
